import { ethers } from 'ethers';
import forgePassABI from '../abi/ForgePassABI.json';

const contractAddress = "0x54Cb56C5a03C2ef71b30059382edc97409601F46";

export const getUserCertifications = async (walletAddress) => {
  try {
    if (!window.ethereum) throw new Error("MetaMask not found");

    const provider = new ethers.BrowserProvider(window.ethereum);
    const signer = await provider.getSigner();

    const contract = new ethers.Contract(contractAddress, forgePassABI, provider).connect(signer);

    const rawCerts = await contract.getCertifications(walletAddress);
    console.log("Raw certifications fetched from contract:", rawCerts);

    return rawCerts.map(cert => ({
      name: cert.name,
      issueDate: new Date(Number(cert.issueDate) * 1000).toISOString().slice(0, 10),
      expirationDate: new Date(Number(cert.expirationDate) * 1000).toISOString().slice(0, 10),
    }));
  } catch (err) {
    console.error("Error fetching certifications:", err);
    return [];
  }
};







